<template>
    <div></div>
</template>

<script>
import { errHandler } from '@/helpers'
export default {
  data () {
    return {
      registrationStatus: {},
      token: ''
    }
  },
  created () {
    this.token = this.$route.params.token
    this.register()
  },
  methods: {
    async register () {
      try {
        await this.$store.dispatch('auth/activate', this.token)
        this.$router.replace({ name: 'auth.login', query: { sticky: 'activeSuccess' } })
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    }
  }
}
</script>
